import React from 'react'
// import PropTypes from 'prop-types'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import { 
  MainTitle, Subtitle,
  TextContent, HighlightText,
  JsonCodeStyle,
} from '../../../Shared';

import { StyledTableCell, StyledTableRow, useTableStyles } from '../../styles/Table.styled';
import { StyledSeparated } from '../FindNearSegments/FindNearSegments.styled';

function createData(fields, type, description) {
  return { fields, type, description };
}

const listBodyUpdate = [
  createData('id','number','id of app'),
  createData('versionCode','Date','code of version'),
  createData('version','string','version of current app'),
  createData('CHplayUrl','string','link download app'),
  createData('appName','string','name of app'),
]

const Application = props => {
  const classes = useTableStyles();

  const responseSuccessGet = {
    "code": 200,
    "message": "success",
    "data": {
        "_id": "5fc90a9c4fd28f04dd976917",
        "id": 1,
        "CHPlayUrl": "https://...",
        "__v": 0,
        "appName": "utraffic android",
        "version": "1.0.1",
        "versionCode": 16
    }
  }

  const responseErrorsGet = {
    "code": 404,
    "message": "Not found",
    "errors": [],
    "debugError": {}
  } 

  const responseSuccessUpdate = {
    "code": 200,
    "message": "success",
    "data": {
        "id": 1,
        "versionCode": 8,
        "version": "1.0.12",
        "CHPlayUrl": "https://google.com",
        "appName": "Utraffic",
        "$setOnInsert": {
            "__v": 0
        }
    }
  }

  return (
    <div>
      <MainTitle>Application</MainTitle>
      <Subtitle id="get-application-info" fontSize={32}>Get Application Information</Subtitle>
      <Subtitle id="request-application">Request</Subtitle>
      <TextContent><b><i>URI: </i></b><HighlightText>/api/app-version/:id</HighlightText> </TextContent>
      <TextContent><b><i>Method: </i></b>@GET</TextContent>

      <Subtitle id="response-application-get">Response</Subtitle>
      <Subtitle isSmall id="success-application-get">Success</Subtitle>
      <JsonCodeStyle data={responseSuccessGet} />

      <Subtitle isSmall id="success-direct">Errors</Subtitle>
      <TextContent>Not Found</TextContent>
      <JsonCodeStyle data={responseErrorsGet} />

      <Subtitle id="update-application-info" fontSize={32}>Update Application Information</Subtitle>
      <Subtitle id="request-application-update">Request</Subtitle>
      <TextContent><b><i>URI: </i></b><HighlightText>/api/app-version/update</HighlightText> </TextContent>
      <TextContent><b><i>Method: </i></b>@POST</TextContent>
      <TextContent><b><i>Body:</i></b></TextContent>

      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>Code</StyledTableCell>
              <StyledTableCell align="left">Message</StyledTableCell>
              <StyledTableCell align="left">Description</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {listBodyUpdate.map((row) => (
              <StyledTableRow key={row.fields}>
                <StyledTableCell>
                  {row.fields}
                </StyledTableCell>
                <StyledTableCell align="left">{
                  row.type
                }</StyledTableCell>
                <StyledTableCell component="th" scope="row" align="left">{
                  row.description
                }</StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Subtitle id="response-application-update">Response</Subtitle>
      <Subtitle isSmall id="success-application-update">Success</Subtitle>
      <JsonCodeStyle data={responseSuccessUpdate} />

      <StyledSeparated />
    </div>
  )
}

Application.propTypes = {

}

export default Application
